'use client';

import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Button, ButtonSize, ButtonType } from '@nx-frontend/shared/ui/button';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';
import { Spinner } from '@nx-frontend/shared/ui/spinner';

interface PortalPageMakeInvisibleProps {
  showLoader?: boolean;
  slideUp?: boolean;
  onClick: () => void;
}

export function PortalPageMakeInvisible({ onClick, showLoader, slideUp }: PortalPageMakeInvisibleProps) {
  const [isShown, setIsShown] = useState<boolean>(false);
  // slideDown animation
  useEffect(() => {
    setIsShown(true);
  }, []);

  // slideUp animation
  useEffect(() => {
    if (isShown && slideUp) {
      setIsShown(false);
    }
  }, [slideUp, isShown]);

  return (
    <div
      data-cy="portal-page-make-invisible-tip"
      className={classNames([
        'w-full flex items-center justify-between bg-yellow-500 bg-opacity-10 pl-[41px] pr-[64px] h-[47px]',
        'transition-all duration-200 ease-out',
        !isShown ? 'translate-y-[-47px] opacity-0' : 'translate-y-0 opacity-1',
        showLoader ? 'pointer-events-none' : '',
      ])}
    >
      <div className="text-[12px] text-neutral-800">
        The page is visible in the Portal. Hide it if you don’t want anyone to see it
      </div>
      <div>
        <Button onClick={onClick} type={ButtonType.STROKED} size={ButtonSize.XL2}>
          {showLoader ? (
            <div className="w-[20px] h-[20px] mr-[8px]">
              <Spinner width={20} height={20} />
            </div>
          ) : (
            <Icon icon={IconsMap.EYE_CLOSE} className="w-[20px] h-[20px] mr-[8px]" />
          )}
          <span>Make invisible</span>
        </Button>
      </div>
    </div>
  );
}
